<template>
<v-container id="main">
<v-row id="row" justify="center" >
      <v-col md="6">
        <v-card
        id="cards" 
        outlined
        class="white main--text pa-8" 
        rounded="xl" 
        align="center"
        height="300"
        elevation="0"
        >
        <v-col>
          <h3> Skip bins </h3>
          <p> 1.5 Cube - 7 Cube Skip Bins </p>
          <img src="@/assets/Skip bins.svg" alt="Avatar" style="width:180px; height:180px; margin-top: -1cm;">
        </v-col>
        </v-card>
      </v-col>
       <v-col md="6">
        <v-card
        id="cards" 
        outlined
        class="main--text white pa-8"  
        rounded="xl"
        height="300" 
        align="center"
        elevation="0"
        
        >
        <v-col>
        <h3> Rorobins </h3>
        <p> 8 Cube - 33 Cube Roro Bins </p>
        <img src="@/assets/Roro.svg" alt="Avatar" style="width:180px; height:180px; margin-top: -1cm;">
        </v-col>
        <br/>       
        </v-card>
      </v-col>
  </v-row>
  <v-row id="row" justify="center">
      <v-col md="6">
        <v-card
        id="cards" 
        outlined
        class="main--text white pa-8"  
        rounded="xl" 
        align="center"
        height="300"
        elevation="0"
        >
        <v-col>
        <h3> Tipper trucks </h3>
        <p> 1 Cube - 10 Cube trucks </p>
        <img src="@/assets/tippertruck.svg" alt="Avatar" style="width:220px; height:180px; margin-top: -0.5cm;">
        </v-col>
        <br/>  
        </v-card>
      </v-col>
       <v-col md="6">
        <v-card
        id="cards"
        outlined 
        class="main--text white pa-8"  
        rounded="xl" 
        align="center"
        height="300"
        elevation="0"
        >
        <v-col>
        <h3> Tanker trucks </h3>
        <p> 1000 Liter - 5000 liter trucks </p>
        <img src="@/assets/tankertruck.svg" alt="Avatar" style="width:250px; height:200px; margin-top: -0.6cm;">
        </v-col>
        <br/>   
        </v-card>
      </v-col>
  </v-row>
</v-container>
</template>

<script>
export default {
  name: 'Service',
}
</script>

<style scoped>
@media only screen and (max-width: 500px){
 #row{
   display: block;
 }
}
</style>